const SortBy = Object.freeze({
  TIME: 'TIME',
  RICHNESS: 'RICHNESS',
  RANDOM: 'RANDOM',
  MOST_ENGAGEMENTS: 'MostEngagements',
  AUTHOR_FOLLOWER: 'AuthorFollower',
  SUBSCRIBER: 'Subscriber',
  OVERALL_STAR_RATING: 'OverallStarRating',
  OVERALL_SURVEY_SCORE: 'OverallSurveyScore',
  NET_PROMOTER_SCORE: 'NetPromoterScore',
  OVERALL_STAR_RATING_ASC: 'OverallStarRatingAsc',
  OVERALL_SURVEY_SCORE_ASC: 'OverallSurveyScoreAsc',
  NET_PROMOTER_SCORE_ASC: 'NetPromoterScoreAsc'
})
export default SortBy
export type SortByStrings = typeof SortBy[keyof typeof SortBy]
// RESERVE BELOW
